/**
 * interfaces
 */
import { ISelectItem } from "../interfaces/select-item";

/**
 * 
 */
export class SelectItemModel<TValue> implements ISelectItem<TValue> {

    /**
     * 
     */
    private _disabled: boolean = false
    public get disabled(): boolean {
        return this._disabled
    }

    /**
     * 
     */
    public selected?: boolean | undefined

    /**
     *
     */
    constructor(
        public id: string | number,
        public value: TValue,
        public label: string,
        public binding: string = 'value'
    ) { }

    /**
     * 
     */
    public getValueBinding(): SelectItemModel<TValue> | TValue | TValue[keyof TValue] {
        
        if (typeof this.binding === 'string' && this.binding.length > 0) {
            
            const keys = this.binding.split('.');
            
            return keys.reduce((p: any, key) => p[key], this);
        }
        
        return this

    }

    /**
     * 
     */
    public disable(): this {
        this._disabled = true;
        return this
    }

    /**
     * 
     */
    public enabled(): this {
        this._disabled = false;
        return this
    }

}